import React from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import AdmarktSimilarItems from './components/AdmarktSimilarItems/AdmarktSimilarItems';
import { TListingClient } from 'types/TListing';

type TAdmarktSimilarItemsAppProps = {
  appState: {
    listing: {
      itemId: TListingClient['itemId'];
      seller: TListingClient['seller'];
      category: TListingClient['category'];
      flags: TListingClient['flags'];
    };
  };
  environment: any;
};

const AdmarktSimilarItemsApp = ({ appState, environment }: TAdmarktSimilarItemsAppProps) => {
  const {
    listing: {
      itemId,
      seller,
      category,
      flags: { requestRelevantItems, isAdmarkt },
    },
  } = appState;
  const {
    experiments: { isSimilarItemsFeedGroupBEnabled, isSimilarItemsFeedGroupCEnabled },
    isMobileDevice,
  } = environment;

  if (isAdmarkt || !requestRelevantItems) {
    return null;
  }

  return (
    <EnvironmentProvider value={environment}>
      <AdmarktSimilarItems
        itemId={itemId}
        sellerId={seller.id}
        category={category}
        isSimilarItemsFeedGroupBEnabled={isSimilarItemsFeedGroupBEnabled && !isMobileDevice}
        isSimilarItemsFeedGroupCEnabled={isSimilarItemsFeedGroupCEnabled && !isMobileDevice}
      />
    </EnvironmentProvider>
  );
};

export default AdmarktSimilarItemsApp;
